import { render } from "./IndustryDetailView.vue?vue&type=template&id=6e9d58de&scoped=true"
import script from "./IndustryDetailView.vue?vue&type=script&lang=js"
export * from "./IndustryDetailView.vue?vue&type=script&lang=js"

import "./IndustryDetailView.vue?vue&type=style&index=0&id=6e9d58de&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9d58de"]])

export default __exports__